module.exports = function anonymous(locals, filters, escape, rethrow
/*``*/) {
escape = escape || function (html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<section class=\"grid-header\"> <div class=\"sponsor-wrapper\"> <img src=\"<%= copy.sponsor_image %>\"> </div> <div class=\"wrapper-text<%- (copy.headline_copy.length===0 && copy.description_copy.length===0? ' hidden' : '' ) %>\"> <h3 <%- (copy.headline_copy.length>0? '' : ' class=\"hidden\" ' ) %>><%- copy.headline_copy %></h3> <p <%- (copy.description_copy.length>0? '' : ' class=\"hidden\" ' ) %>><%- copy.description_copy %></p> </div> </section> <% if (length < 1) { %> <div class=\"grid-error\"> <h2>No Results</h2> <p>Expand your search and try again.</p> </div> <% } else { %> <div class=\"voting-grid-options\"></div> <% }  %> <div class=\"grid-footer\"> <div class=\"rules-wrapper\"> <a href=\"<%= copy.rules_url %>\" target=\"_blank\" rel=\"noopener noreferrer\"><%= copy.rules_copy %></a> </div> | <div class=\"user-wrapper\"></div> </div> ", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<section class="grid-header"> <div class="sponsor-wrapper"> <img src="', escape((__stack.lineno=1,  copy.sponsor_image )), '"> </div> <div class="wrapper-text', (__stack.lineno=1,  (copy.headline_copy.length===0 && copy.description_copy.length===0? ' hidden' : '' ) ), '"> <h3 ', (__stack.lineno=1,  (copy.headline_copy.length>0? '' : ' class="hidden" ' ) ), '>', (__stack.lineno=1,  copy.headline_copy ), '</h3> <p ', (__stack.lineno=1,  (copy.description_copy.length>0? '' : ' class="hidden" ' ) ), '>', (__stack.lineno=1,  copy.description_copy ), '</p> </div> </section> ');__stack.lineno=1; if (length < 1) { ; buf.push(' <div class="grid-error"> <h2>No Results</h2> <p>Expand your search and try again.</p> </div> ');__stack.lineno=1; } else { ; buf.push(' <div class="voting-grid-options"></div> ');__stack.lineno=1; }  ; buf.push(' <div class="grid-footer"> <div class="rules-wrapper"> <a href="', escape((__stack.lineno=1,  copy.rules_url )), '" target="_blank" rel="noopener noreferrer">', escape((__stack.lineno=1,  copy.rules_copy )), '</a> </div> | <div class="user-wrapper"></div> </div> '); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/templates/grid.ejs
// module id = 64
// module chunks = 0